import React from "react";

interface Language {
  language_name: string;
  iso639_tag: string;
}

interface FormUpdate {
  updateType: string;
  value: string;
}

interface SingleLanguageSelectorProps {
  label: string;
  selectedValue: string;
  updateType: string;
  updateFormValue: (update: FormUpdate) => void;
  languages: Language[];
  disabled?: boolean;
  exclude?: string[];
}

const SingleLanguageSelector = ({ label, selectedValue, updateType, updateFormValue, languages, disabled, exclude }: SingleLanguageSelectorProps) => {
    return (
      <div className="form-control w-full">
        <div className="label">
          <span className="label-text">{label}</span>
        </div>
        <select
          className="select select-sm select-bordered"
          value={selectedValue}
          disabled={disabled}
          onChange={(e) =>
            updateFormValue({
              updateType: updateType,
              value: e.target.value
            })
          }
        >
          <option disabled value="">Selecciona uno</option>
          {languages
            .filter((language) => !exclude?.includes(language.iso639_tag))
            .map((language, index) => (
              <option key={index} value={language.iso639_tag}>
                {language.language_name}
              </option>
            ))}
        </select>
      </div>
    );
  };
  
  export default SingleLanguageSelector;